module.exports = __webpack_public_path__ + "img/user27.9b2c61b0.jpg";